var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 18,
    viewBox: "0 0 12 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.59861 0H6.67396H1.49887C1.49887 0 3.30307e-05 0.0212942 3.30307e-05 1.49474L0 11.1288V16.5054C0 17.3295 0.672372 18 1.49894 18H9.59868C10.4252 18 11.0975 17.3295 11.0975 16.5054V1.49461C11.0975 0.670466 10.4251 0 9.59861 0ZM10.0733 16.5054C10.0733 16.7664 9.86033 16.9787 9.59861 16.9787H1.49887C1.23714 16.9787 1.02413 16.7664 1.02413 16.5054V14.8029H10.0733V16.5054ZM10.0733 13.7816H1.02413V1.49461C1.02413 1.23363 1.23707 1.02129 1.49887 1.02129H9.59861C9.86033 1.02129 10.0733 1.23363 10.0733 1.49461V13.7816ZM4.57581 16.4015H6.39157C6.67438 16.4015 6.90371 16.1729 6.90371 15.8908C6.90371 15.6088 6.67445 15.3801 6.39157 15.3801H4.57581C4.293 15.3801 4.06368 15.6087 4.06368 15.8908C4.06375 16.1729 4.293 16.4015 4.57581 16.4015ZM6.39157 1.54023H4.57581C4.293 1.54023 4.06368 1.76884 4.06368 2.05091C4.06368 2.33292 4.29293 2.56159 4.57581 2.56159H6.39157C6.67438 2.56159 6.90371 2.33299 6.90371 2.05091C6.90371 1.76884 6.67438 1.54023 6.39157 1.54023Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.bf8313c58553b1c3eeeef72d460d1a2b.svg";
export { ForwardRef as ReactComponent };